// extracted by mini-css-extract-plugin
export default {"activityDesc":"activityDesc_kJ28T","goldenBg":"goldenBg_Y0weN","icon":"icon__Op24","activityBanner":"activityBanner_XWYEh"};